var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6763 7.35946C19.1079 7.83874 19.1079 8.61581 18.6763 9.09509L12.7815 15.6405C12.3499 16.1198 11.6501 16.1198 11.2185 15.6405L5.32372 9.09509C4.89209 8.61581 4.89209 7.83874 5.32372 7.35946C5.75536 6.88018 6.45517 6.88018 6.8868 7.35946L12 13.0371L17.1132 7.35946C17.5448 6.88018 18.2446 6.88018 18.6763 7.35946Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.bed9d56af5a1162effa09068acf9c3fd.svg";
export { ForwardRef as ReactComponent };